import { FileDropZone } from '../../../design-system/file-drop-zone/file-drop-zone';
import { PaymentFlowStepWrapper } from '../components/payment-flow-step-wrapper';
import { PaymentsFlowContentWrapper } from '../components/payments-flow-content-wrapper';

type BillPayUploadInvoiceFlowProps = {
  onGoBack: () => void;
  onUploadInvoice: (files: File[]) => void;
  isUploadingInvoice: boolean;
};

export const BillPayUploadInvoiceFlow = ({
  onGoBack,
  onUploadInvoice,
  isUploadingInvoice,
}: BillPayUploadInvoiceFlowProps) => {
  return (
    <PaymentsFlowContentWrapper>
      <PaymentFlowStepWrapper onGoBack={onGoBack} title="Upload an invoice">
        <div className="mt-20">
          <FileDropZone
            variant="STACKED"
            onDropAccepted={onUploadInvoice}
            isLoading={isUploadingInvoice}
            fileDescription="invoice"
            supportedFileTypes={['PDF']}
          />
        </div>
      </PaymentFlowStepWrapper>
    </PaymentsFlowContentWrapper>
  );
};
